import { Root } from '@radix-ui/react-separator'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'
import { cn } from '#src/cn.ts'
import { TypographyDetail } from '#src/components/Typography/TypographyDetail.tsx'

export const Separator = forwardRef<
  ElementRef<typeof Root>,
  ComponentPropsWithoutRef<typeof Root>
>(
  (
    {
      className,
      children,
      orientation = 'horizontal',
      decorative = true,
      ...props
    },
    ref
  ) => {
    if (children) {
      return (
        <div ref={ref} className={cn('flex items-center gap-2', className)}>
          <Root
            orientation={orientation}
            className={cn(
              'bg-border',
              orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]'
            )}
            {...props}
          />
          <TypographyDetail className="shrink-0 text-muted-foreground">
            {children}
          </TypographyDetail>
          <Root
            orientation={orientation}
            className={cn(
              'bg-border',
              orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]'
            )}
            {...props}
          />
        </div>
      )
    }
    return (
      <Root
        ref={ref}
        decorative={decorative}
        orientation={orientation}
        className={cn(
          'shrink-0 bg-border',
          orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]',
          className
        )}
        {...props}
      />
    )
  }
)
Separator.displayName = Root.displayName
